import { render, staticRenderFns } from "./Brasspire.vue?vue&type=template&id=7b42cd80&"
import script from "./Brasspire.vue?vue&type=script&lang=js&"
export * from "./Brasspire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports